import api from './api';
import { Document } from '../types';

export const documentsService = {
  // Upload document
  async upload(data: FormData): Promise<Document> {
    const response = await api.post('/documents/upload', data);
    return response.data;
  },

  // Get document by ID
  async getById(id: string): Promise<Document> {
    const response = await api.get(`/documents/${id}`);
    return response.data;
  },

  // Delete document
  async delete(id: string): Promise<void> {
    await api.delete(`/documents/${id}`);
  },
};
